import request from "src/utils/request";
import useApi from "src/utils/api/use-api";
import { sleep } from "src/utils/api/mock-utils";
import { useAuth } from "src/components/providers/auth-context";

const useOrgMembersApi = () => {
    const { user, userHasTeamsSubscription } = useAuth();

    const getMockData = async () => {
        await sleep();
        return [
            {
                id: "b2595224-51c3-4e67-8184-eeb96aa59cb1",
                displayName: "Orfeus Panagathos",
                jobTitle: "Grandmaster Developer",
                picture: "https://assets-sit.adadot.com/b2595224-51c3-4e67-8184-eeb96aa59cb1.png",
                email: "o.panagathos@adadot.com",
            },
            {
                id: "6d737aa5-b8a5-464a-8e93-215f65d3b02a",
                displayName: "Laurel Halo",
                jobTitle: "Grandmaster Developer",
                picture: "https://assets-sit.adadot.com/6d737aa5-b8a5-464a-8e93-215f65d3b02a.png",
                email: "l.halo@adadot.com",
            },
            {
                id: "bc9af2b7-f342-4878-bace-6be7164604f1",
                displayName: "Wang Harrison",
                jobTitle: "Fullstack Developer",
                picture: "https://assets-sit.adadot.com/bc9af2b7-f342-4878-bace-6be7164604f1.png",
                email: "w.harrison@adadot.com",
            },
            {
                id: "60c22d90-a686-43f9-b715-33e77f6226db",
                displayName: "Stacey Hobgoblens",
                jobTitle: "Frontend Developer",
                picture: "https://assets-sit.adadot.com/60c22d90-a686-43f9-b715-33e77f6226db.png",
                email: "s.hobgoblens@adadot.com",
            },
            {
                id: "72ec4dfe-d9c5-4da1-9fe9-7697165c0640",
                displayName: "Ibi Jetson",
                jobTitle: "Decent Developer",
                picture: "https://assets-sit.adadot.com/72ec4dfe-d9c5-4da1-9fe9-7697165c0640.png",
                email: "i.jetson@adadot.com",
            },
            {
                id: "c4d21b4f-bd52-42a9-82b9-25e5c6a14933",
                displayName: "Natasha Green",
                jobTitle: "Data Scientist",
                picture: "https://assets-sit.adadot.com/c4d21b4f-bd52-42a9-82b9-25e5c6a14933.png",
                email: "n.green@adadot.com",
            },
            {
                id: "1e9f02a8-cf1a-40c9-8d70-8f4e6452c2a4",
                displayName: "Larry Lalonde",
                jobTitle: "Frontend Monkey",
                picture: "https://assets-sit.adadot.com/1e9f02a8-cf1a-40c9-8d70-8f4e6452c2a4.png",
                email: "l.lalonde@adadot.com",
            },
            {
                id: user.id,
                displayName: user.displayName,
                jobTitle: user.jobTitle,
                picture: user.picture,
                email: user.email,
            },
            {
                id: "d4d21b4f-bd52-42a9-82b9-25e5c6a14933",
                displayName: "Asher Fox",
                jobTitle: "Data Scientist",
                email: "a.fox@adadot.com",
            },
            {
                id: "e4d21b4f-bd52-42a9-82b9-25e5c6a14933",
                displayName: "Benedict Hart",
                jobTitle: "Fullstack Developer",
                email: "b.hart@adadot.com",
            },
            {
                id: "f4d21b4f-bd52-42a9-82b9-25e5c6a14933",
                displayName: "Emilie Gardner",
                jobTitle: "Fullstack Developer",
                email: "e.gardner@adadot.com",
            },
            {
                id: "f4d21b4f-bd52-42a9-82b9-25e5c6a14933",
                displayName: "Louisa Marshall",
                jobTitle: "Frontend Developer",
                email: "l.marshall@adadot.com",
            },
            {
                id: "f4d21b4f-bd52-42a9-82b9-25e5c6a14933",
                displayName: "Chris Morris",
                jobTitle: "Backend Developer",
                email: "c.morris@adadot.com",
            },
        ];
    };
    if (!userHasTeamsSubscription) return useApi(() => getMockData());
    return useApi(() => request(`/api/users/all-unregistered`));
};

export default useOrgMembersApi;
